import React from 'react';
import { Button } from 'antd';

const Columns = (disableSubmit, processing, updating, deleting, handleUpdate, handleDelete) => {
  return [
    {
      title: 'Email',
      dataIndex: 'email',
      width: '20%',
      align: 'left',
    },
    {
      title: 'Phân quyền',
      dataIndex: 'role',
      editable: true,
      width: '20%',
      align: 'center',
    },
    {
      title: 'Line manager',
      dataIndex: 'line_manager',
      editable: true,
      width: '20%',
      align: 'center',
    },
    {
      title: 'Tùy chỉnh',
      align: 'center',
      render: (text, record) => <div style={{ marginTop: 16 }}>
        <Button loading={processing === record.id && updating} disabled={disableSubmit === record.id || (processing === record.id && deleting)} onClick={() => handleUpdate(record.id)} icon='check' type='primary'>Save</Button>
        <Button loading={processing === record.id && deleting} disabled={processing === record.id && updating} onClick={() => handleDelete(record.id)} icon='delete' type='danger'>Delete</Button>
      </div>,
    },
  ];
};

export default Columns;
